import { campaignLevels, validateCampaignLevels } from '@algoquest/shared/campaign';
import { loadLevel } from './levelLoader';

const problems = validateCampaignLevels();
if (problems.length) throw new Error(`Invalid campaign: ${problems.join('; ')}`);
export const campaign = campaignLevels.map(loadLevel).sort((a,b)=>a.definition.coordinates.globalLevelNumber-b.definition.coordinates.globalLevelNumber);
export const campaignWorlds = [
  { name: 'Searching Fundamentals', description: 'Discover targets, packages, and comparisons.' },
  { name: 'Linear Search', description: 'Inspect in order. Stop when the target is found.' },
  { name: 'Binary Search', description: 'Find the middle. Eliminate half of the range.' },
  { name: 'Search Challenge', description: 'Choose a search strategy that fits the data.' },
  { name: 'Sorting Fundamentals', description: 'Compare values and put packages in order.' },
  { name: 'Bubble Sort', description: 'Compare neighbours, swap or keep, and repeat.' },
  { name: 'Selection Sort', description: 'Track the best candidate and place it.' },
  { name: 'Insertion Sort', description: 'Carry a key. Shift values to make room.' },
  { name: 'Sorting Challenge', description: 'Choose and compare three sorting strategies.' },
  { name: 'Algorithm Lab', description: 'Sort first, then search the same packages.' },
].map((world,index)=>({...world,number:index+1,levels:campaign.filter(level=>level.definition.coordinates.world===index+1)}));

export function campaignLevel(number: number) {
  const level = campaign.find(item=>item.definition.coordinates.globalLevelNumber===number);
  if (!level) throw new RangeError(`Unknown campaign level ${number}`);
  return level;
}
export function nextCampaignLevel(number: number): number | null {
  return campaign.find(item=>item.definition.coordinates.globalLevelNumber>number)?.definition.coordinates.globalLevelNumber ?? null;
}
export function recommendedCampaignLevel(completed: ReadonlySet<number>): number {
  return campaign.find(item=>!completed.has(item.definition.coordinates.globalLevelNumber))?.definition.coordinates.globalLevelNumber ?? 100;
}
